import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-grid" }
const _hoisted_2 = { class: "d-flex justify-center" }
const _hoisted_3 = { class: "text-medium-emphasis" }
const _hoisted_4 = { class: "d-flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_date_picker_wrapper = _resolveComponent("v-date-picker-wrapper")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_form, {
      modelValue: _ctx.isValid,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isValid) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_date_picker_wrapper, {
              modelValue: _ctx.dates,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dates) = $event)),
                _ctx.onDatesChanged
              ],
              multiple: "range",
              color: "primary",
              "hide-header": "",
              max: _ctx.maxDate,
              "first-day-of-week": 1
            }, null, 8, ["modelValue", "max", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datePickerErrors, (error, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: `error-date-picker-${index}`,
                class: "text-red animation-rize-shaking"
              }, _toDisplayString(error), 1))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.isValid)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" La synchronisation sera effectuée pour la période du " + _toDisplayString(_ctx.formatDate(_ctx.dates[0])) + " au " + _toDisplayString(_ctx.formatDate(_ctx.dates[_ctx.dates.length - 1])) + " (" + _toDisplayString(_ctx.dates.length) + " jours) ", 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_btn, {
            onClick: _ctx.connectorSync,
            disabled: !_ctx.isValid,
            class: "mt-4",
            rounded: "",
            elevation: "0"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode(" Relancer la synchronisation ")
            ])),
            _: 1
          }, 8, ["onClick", "disabled"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}